// extracted by mini-css-extract-plugin
module.exports = {"technologyBox":"PoweredBy_technologyBox__1LzXw"};